document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('SiloekSearchDrawer');
  const overlay = document.querySelector('.siloek-search-overlay');
  const openTriggers = document.querySelectorAll('.js-search-drawer-open');
  const closeTriggers = document.querySelectorAll('.js-search-close');
  
  const input = document.getElementById('SiloekSearchInput');
  const clearBtn = document.querySelector('.js-search-clear');
  const loading = document.querySelector('.js-search-loading');
  const resultsContainer = document.querySelector('.js-search-results-list');
  const emptyState = document.querySelector('.js-search-empty');
  const emptyQuery = document.querySelector('.js-empty-query');
  
  const historyContainer = document.querySelector('.js-search-history-container');
  const historyList = document.querySelector('.js-search-history-list');
  const clearHistoryBtn = document.querySelector('.js-clear-history');

  const HISTORY_KEY = 'siloek_search_history';
  let debounceTimer;

  // --- DRAWER TOGGLE ---
  function openDrawer(e) {
    if (e) e.preventDefault();
    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
    setTimeout(() => input.focus(), 300);
    renderHistory();
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  openTriggers.forEach(t => t.addEventListener('click', openDrawer));
  closeTriggers.forEach(t => t.addEventListener('click', closeDrawer));

  // --- SEARCH HISTORY ---
  function getHistory() {
    return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
  }

  function saveToHistory(query) {
    if (!query.trim()) return;
    let history = getHistory();
    // Remove if exists to put it at the beginning
    history = history.filter(item => item.toLowerCase() !== query.toLowerCase());
    history.unshift(query);
    if (history.length > 5) history.pop(); // Keep only last 5
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  }

  function renderHistory() {
    const history = getHistory();
    if (history.length > 0 && input.value.trim() === '') {
      historyContainer.style.display = 'block';
      historyList.innerHTML = history.map(item => 
        `<button type="button" class="search-history-pill js-history-pill">${item}</button>`
      ).join('');
      
      // Bind clicks to pills
      document.querySelectorAll('.js-history-pill').forEach(pill => {
        pill.addEventListener('click', function() {
          input.value = this.textContent;
          performSearch(this.textContent);
        });
      });
    } else {
      historyContainer.style.display = 'none';
    }
  }

  clearHistoryBtn.addEventListener('click', function() {
    localStorage.removeItem(HISTORY_KEY);
    renderHistory();
  });

  // --- PREDICTIVE SEARCH ---
  function performSearch(query) {
    clearBtn.style.display = query.length > 0 ? 'block' : 'none';
    
    if (query.trim() === '') {
      resultsContainer.innerHTML = '';
      emptyState.style.display = 'none';
      renderHistory();
      return;
    }

    historyContainer.style.display = 'none';
    loading.style.display = 'flex';
    resultsContainer.innerHTML = '';
    emptyState.style.display = 'none';

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`)
      .then(response => response.json())
      .then(data => {
        loading.style.display = 'none';
        const products = data.resources.results.products;
        
        if (products && products.length > 0) {
          resultsContainer.innerHTML = products.map(product => {
            return `
              <a href="${product.url}" class="search-result-item">
                ${product.image ? `<img src="${product.image}" class="search-result-image" alt="${product.title}">` : '<div class="search-result-image"></div>'}
                <div class="search-result-info">
                  <div class="search-result-title">${product.title}</div>
                  <div class="search-result-type">${product.type || 'Product'}</div>
                  <div class="search-result-price">${product.price}</div>
                </div>
              </a>
            `;
          }).join('');
        } else {
          emptyQuery.textContent = query;
          emptyState.style.display = 'block';
        }
      })
      .catch(error => {
        loading.style.display = 'none';
        console.error('Error fetching predictive search:', error);
      });
  }

  // --- EVENT LISTENERS ---
  input.addEventListener('input', function(e) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch(e.target.value);
    }, 300);
  });

  input.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      saveToHistory(input.value);
      window.location.href = `/search?q=${encodeURIComponent(input.value)}&type=product`;
    }
  });

  resultsContainer.addEventListener('click', function(e) {
    const item = e.target.closest('.search-result-item');
    if (item) {
      saveToHistory(input.value);
    }
  });

  clearBtn.addEventListener('click', function() {
    input.value = '';
    input.focus();
    performSearch('');
  });
});
